import { cellRenderStockLevel } from '../../../utils/functions';

/** Список полей */
export const columnTreeList = [
  {
    dataField: 'description',
    caption: 'Имя',
    dataType: 'string'
  },
  {
    dataField: 'stockConfigCode',
    dataType: 'string',
    caption: 'Конф. завода'
  },
  {
    dataField: 'stockLevelTypeNumId',
    dataType: 'string',
    caption: 'Описание конфигуратора',
    cellRender: cellRenderStockLevel
  },
  {
    dataField: 'holderId',
    dataType: 'string',
    caption: 'Q-дебитор'
  },
  {
    dataField: 'sapCode',
    dataType: 'string',
    caption: 'Код склада SAP'
  }
];
